import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';

class ConfidentialServersList extends Component {

    updateConfigCount() {
        const { match, list, sliderPriceFrom, sliderPriceTo, sliderRamFrom, sliderRamTo, sliderStorageFrom, sliderStorageTo, countConfigs } = this.props;
        if (!countConfigs || !list) return;
        
        const id = match ? match.params.id : null;
        const filteredList = !id ? list : list.filter((a) => a.id === Number(id));
        
        const FilterConditions = filteredList.filter((a) =>
            a.price >= sliderPriceFrom
            && a.price <= sliderPriceTo
            && a.config.ram >= sliderRamFrom
            && a.config.ram <= sliderRamTo
            && a.config.storage >= sliderStorageFrom
            && a.config.storage <= sliderStorageTo
        ).sort((a, b) => a.price - b.price);
        
        countConfigs(FilterConditions.length);
    }

    componentDidMount() {
        this.updateConfigCount();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.list !== this.props.list || 
            prevProps.sliderPriceFrom !== this.props.sliderPriceFrom ||
            prevProps.sliderPriceTo !== this.props.sliderPriceTo ||
            prevProps.sliderRamFrom !== this.props.sliderRamFrom ||
            prevProps.sliderRamTo !== this.props.sliderRamTo ||
            prevProps.sliderStorageFrom !== this.props.sliderStorageFrom ||
            prevProps.sliderStorageTo !== this.props.sliderStorageTo ||
            (prevProps.match && prevProps.match.params.id) !== (this.props.match && this.props.match.params.id)) {
            this.updateConfigCount();
        }
    }

    generateJsonLd(products) {
        const jsonLdProducts = products.map((product) => {
            const usdRate = this.props.usdRate,
            eurRate = this.props.eurRate,
            osTemplates = this.props.os_templates
            .map((osTemplate) => osTemplate.name);

            return {
                "@type": "Product",
                "name": product.name,
                'sku': product.id,
                "image": "https://swissmade.host/images/products/confidential-server-product.png",
                'brand': {
                    '@type': 'Brand',
                    'name': 'SWISSMADE.HOST'
                },
                "description": `A Swiss-based confidential computing server with ${product.config.cores} CPU cores, ${product.config.ram} MB of RAM, ${product.config.storage} GB NVMe storage. Features AMD SEV memory encryption, always-on disk encryption, and user-controlled encryption keys.`,
                "offers": {
                    "@type": "Offer",
                    'url': "https://swissmade.host/en/confidential-servers-switzerland",
                    "priceCurrency": "CHF",
                    "price": product.price,
                    "priceValidUntil": new Date(new Date().setFullYear(new Date().getFullYear() + 1)).toISOString().split('T')[0],
                    "priceSpecification": [
                        {
                          "@type": "UnitPriceSpecification",
                          "price": parseFloat((product.price * (Number(usdRate))).toFixed(2)),
                          "priceCurrency": "USD"
                        },
                        {
                          "@type": "UnitPriceSpecification",
                          "price": parseFloat((product.price * (Number(eurRate))).toFixed(2)),
                          "priceCurrency": "EUR"
                        }
                      ],
                    "areaServed": "Worldwide",
                    "availability": "https://schema.org/InStock",
                    'seller': {
                        '@type': 'Organization',
                        'name': 'SWISSMADE.HOST'
                    },
                    'category': 'Confidential Computing Hosting',
                    'itemCondition': 'https://schema.org/NewCondition'
                },
                "additionalProperty": [
                    {
                      "@type": "PropertyValue",
                      "name": "CPU cores",
                      "value": product.config.cores
                    },
                    {
                      "@type": "PropertyValue",
                      "name": "RAM",
                      "value": product.config.ram + " MB"
                    },
                    {
                      "@type": "PropertyValue",
                      "name": "Storage",
                      "value": product.config.storage + " GB NVMe"
                    },
                    {
                        "@type": "PropertyValue",
                        "name": "Memory Encryption",
                        "value": "AMD SEV"
                    },
                    {
                        "@type": "PropertyValue",
                        "name": "Disk Encryption",
                        "value": "AES-256 (always-on)"
                    },
                    {
                        "@type": "PropertyValue",
                        "name": "User-Controlled Keys",
                        "value": "Yes (exclusive control panel)"
                    },
                    {
                        "@type": "PropertyValue",
                        "name": "Bandwidth",
                        "value": "10 Gbps (no oversubscription)"
                    },
                    {
                        "@type": "PropertyValue",
                        "name": "DDoS Protection",
                        "value": "Optional (available as add-on)"
                    },
                    {
                        "@type": "PropertyValue",
                        "name": "Backup",
                        "value": product.config.backup_included ? "Included free of charge" : "Available"
                    },
                    {
                        "@type": "PropertyValue",
                        "name": "Supported Operating Systems",
                        "value": osTemplates
                    },
                    {
                        "@type": "PropertyValue",
                        "name": "Location",
                        "value": "Zurich, Switzerland"
                    },
                    {
                        "@type": "PropertyValue",
                        "name": "Uptime SLA",
                        "value": "99.99%"
                    }
                ]
            }
        });

        if (!this.props.id)
         return (
            {
                "@context": "https://schema.org/",
                "@type": "ItemList",
                "name": "Confidential Computing Server offerings by Swiss Made Host",
                "itemListElement": [jsonLdProducts]
            }
            )
        else {
            return (
                {
                    "@context": "https://schema.org/",
                    "@type": "Product",
                    ...jsonLdProducts[0]
                }
            )
        }
    }

    render() {
        const { history, match } = this.props,
            id = match ? match.params.id : null,
            list = !id ? this.props.list : this.props.list.filter((a) => a.id === Number(id)),
            payment_period = this.props.payment_period,
            usdRate = this.props.usdRate,
            eurRate = this.props.eurRate,
            price_from = this.props.sliderPriceFrom,
            price_to = this.props.sliderPriceTo,
            ram_from = this.props.sliderRamFrom,
            ram_to = this.props.sliderRamTo,
            storage_from = this.props.sliderStorageFrom,
            storage_to = this.props.sliderStorageTo,
            FilterConditions =
                list.filter((a) =>
                    a.price >= price_from
                    && a.price <= price_to
                    && a.config.ram >= ram_from
                    && a.config.ram <= ram_to
                    && a.config.storage >= storage_from
                    && a.config.storage <= storage_to
                ).sort((a, b) => a.price - b.price)

        if (this.props.usdRate !== undefined && this.props.list !== undefined) {
            const jsonLdData = this.generateJsonLd(
                !this.props.id
                    ? this.props.list
                    : this.props.list.filter((a) => a.id === Number(this.props.id))
            );
            this.props.onJsonLdGenerated(jsonLdData);
        }
        
        return (
            <div className="fullwidth light">
                {FilterConditions.length > 0 ? FilterConditions.map((item, i) =>
                    <div className="row" key={i}>
                        <div className="twelve columns">
                            <div className="panel pricing">
                                <div className="twelve columns">
                                    <div className="four columns">
                                        <h3 className="config">
                                            <span className="colored">{item.name}</span>
                                        </h3>
                                    </div>
                                    <div className='eight columns'>
                                        {item.config.backup_included &&
                                            <span className="tag right">FREE BACKUP</span>
                                        }
                                        <span className="tag right">HARDWARE ENCRYPTED</span>
                                    </div>
                                </div>
                                <hr className="black" />
                                <div className="eight columns">
                                    <ul className="dp">
                                        <li>
                                            <span className="name"><i className="fa fa-caret-right colored" aria-hidden="true"></i>CPU Cores</span>
                                            <span className="value">{item.config.cores} cores</span>
                                        </li>
                                        <li>
                                            <span className="name"><i className="fa fa-caret-right colored" aria-hidden="true"></i>RAM</span>
                                            <span className="value">{Math.round(item.config.ram / 1024)} GB</span>
                                        </li>
                                        <li>
                                            <span className="name"><i className="fa fa-caret-right colored" aria-hidden="true"></i>Storage</span>
                                            <span className="slash">{item.config.storage} GB NVMe (recommended, minimum 10 GB, each GB: 0.43 CHF)</span>
                                        </li>
                                        <li>
                                            <span className="name"><i className="fa fa-caret-right colored" aria-hidden="true"></i>Network</span>
                                            <span className="slash">10 Gbps dedicated bandwidth</span>
                                        </li>
                                        <li className="protection">
                                            <span className="name"><i className="fa fa-caret-right colored" aria-hidden="true"></i>Memory Encryption</span>
                                            <span className="value"><i className="fa fa-shield-alt" aria-hidden="true"></i> AMD SEV Confidential Computing</span>
                                        </li>
                                        <li className="protection">
                                            <span className="name"><i className="fa fa-caret-right colored" aria-hidden="true"></i>Disk Encryption</span>
                                            <span className="value">Always-on (included)</span>
                                        </li>
                                        <li className="protection">
                                            <span className="name"><i className="fa fa-caret-right colored" aria-hidden="true"></i>DDoS Protection</span>
                                            <span className="value">Optional (available as add-on)</span>
                                        </li>
                                        <li className="protection">
                                            <span className="name"><i className="fa fa-caret-right colored" aria-hidden="true"></i>Backup</span>
                                            {item.config.backup_included
                                                ? <span className="value">Included</span>
                                                : <span className="value">Available</span>}
                                        </li>
                                    </ul>
                                    {!this.props.id && <span className="expand-products" title="View configuration details" onClick={this.toggleAnimation} animation-id={item.id}><i className="fa fa-caret-down colored" aria-hidden="true"></i>View all specifications</span>}
                                    <ul className={!this.props.id ? "nobullet co expandInfo" : "nobullet co expandInfo expanded"} id={"details-" + item.id}>
                                        <li>
                                            <span className="name">Server Location</span><span>Zurich, Switzerland</span>
                                        </li>
                                        <li>
                                            <span className="name">Network</span><span>10 Gbps port / 1 IPv4 address</span>
                                        </li>
                                        <li>
                                            <span className="name">DDoS Protection</span><span>Optional (available as add-on)</span>
                                        </li>
                                        <li>
                                            <span className="name">OS Templates</span><span>Encrypted Linux images</span>
                                        </li>
                                        <li>
                                            <span className="name">Support</span><span>24/7 Live</span>
                                        </li>
                                        <li>
                                            <span className="name">Billing Cycle</span><span>1 to 12 months</span>
                                        </li>
                                        <li>
                                            <span className="name">Encryption Technology</span><span>AMD SEV (Secure Encrypted Virtualization)</span>
                                        </li>
                                        <li>
                                            <span className="name">User-Controlled Keys</span><span>Yes (exclusive control panel)</span>
                                        </li>
                                        <li>
                                            <span className="name">Performance</span><span>~90K read IOPS, ~38K write IOPS, sub-millisecond latency</span>
                                        </li>
                                        <li>
                                            <span className="name">Uptime SLA</span><span>99.99%</span>
                                        </li>
                                    </ul>
                                </div>
                                <div className="four columns">
                                    <div className="row">
                                        <div className="twelve columns monthly-fee margintop">

                                            <span className="chf">{
                                                (payment_period === 1
                                                    ? item.old_price === 0
                                                        ? new Intl.NumberFormat('de-CH', { style: 'currency', currency: 'CHF' }).format(item.price)
                                                        : <React.Fragment><span style={{ color: '#D74937', textDecoration: 'line-through', fontSize: '0.7em', fontWeight: 'normal' }}><span style={{ color: '#2D2D2D' }}>{new Intl.NumberFormat('de-CH', { style: 'currency', currency: 'CHF' }).format(item.old_price !== 0 ? item.old_price : item.price)}</span></span><br />
                                                            {new Intl.NumberFormat('de-CH', { style: 'currency', currency: 'CHF' }).format((item.price - (item.price / 100 * (payment_period - 1) * 2)))}
                                                        </React.Fragment>
                                                    : <React.Fragment><span style={{ color: '#D74937', textDecoration: 'line-through', fontSize: '0.7em', fontWeight: 'normal' }}><span style={{ color: '#2D2D2D' }}>{new Intl.NumberFormat('de-CH', { style: 'currency', currency: 'CHF' }).format(item.old_price !== 0 ? item.old_price : item.price)}</span></span><br />
                                                        {new Intl.NumberFormat('de-CH', { style: 'currency', currency: 'CHF' }).format((item.price - (item.price / 100 * (payment_period - 1) * 2)))}
                                                    </React.Fragment>)
                                            }</span>
                                            <div className="usd">USD <span className="val">{
                                                ((item.price - (item.price / 100 * (payment_period - 1) * 2)) * usdRate).toFixed(2)
                                            }</span>
                                            </div>
                                            <div className="eur">EUR <span className="val">{
                                                ((item.price - (item.price / 100 * (payment_period - 1) * 2)) * eurRate).toFixed(2)
                                            }</span>
                                            </div>
                                            <span className="month">per month</span>
                                        </div>
                                    </div>
                                    <span className="link-for-storage_w"><a className="button radius large right" href={"//" + process.env.REACT_APP_MEMBER_DOMAIN + "/en/cart/add/" + item.id + "?bill=" + payment_period} title="Configure and place order">{item.old_price !== 0 || payment_period > 1 ? 'Buy with discount' : 'Configure'}</a></span>                               
                                     </div>
                            </div>
                        </div>
                    </div>
                )

                    : !id ?
                    <div className="row">
                        <div className="twelve columns">
                            <div className="panel pricing">
                                <h3>No Match</h3>
                                <p>No confidential server configuration matches your requirements. Please relax search parameters or reset the filters.</p>
                            </div>
                        </div>
                    </div>
                    : history.push('/en/error-404')
                }
            </div>
        )
    }
    toggleAnimation = (e) => {
        document.getElementById("details-" + e.target.getAttribute('animation-id')).classList.toggle('expanded')
    }
}

export default withRouter(ConfidentialServersList);
